"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _MaterialIcon = _interopRequireDefault(require("../MaterialIcon"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styled = require("./styled");
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const Accordion = _ref => {
  let {
    children,
    defaultOpened = false,
    disabled = false,
    margin = '10px',
    noPrint = false,
    title = '',
    onToggle = () => null
  } = _ref;
  const [opened, setOpened] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    setOpened(!!defaultOpened);
  }, [defaultOpened]);
  const handleToggle = () => {
    setOpened(opened => !opened);
    onToggle();
  };
  const containerProps = {
    margin,
    noPrint
  };
  const contentProps = {
    opened
  };
  const titleProps = {
    opened
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.Container, _objectSpread(_objectSpread({}, containerProps), {}, {
    "data-testid": "Accordion",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.TitleContainer, _objectSpread(_objectSpread({}, titleProps), {}, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.Title, {
        "data-testid": "Title",
        children: title
      }), !disabled && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.IconContainer, {
        "data-testid": "Toggle",
        onClick: handleToggle,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MaterialIcon.default, {
          icon: !opened ? 'expand_more' : 'expand_less'
        })
      })]
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.Content, _objectSpread(_objectSpread({}, contentProps), {}, {
      "data-testid": "Content",
      children: children
    }))]
  }));
};
Accordion.propTypes = {
  children: _propTypes.default.any,
  defaultOpened: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  margin: _propTypes.default.string,
  noPrint: _propTypes.default.bool,
  onToggle: _propTypes.default.func,
  title: _propTypes.default.string
};
var _default = exports.default = Accordion;